import { Checkbox } from 'primereact/checkbox';
import React from 'react';
import { UserPermissionValue } from '../../../../../api/types/user/permissions/user-permission-value';

export interface UserPermissionRowModel {
  permissionName: string;
  read: boolean;
  write: boolean;
  onChange: (type: UserPermissionValue) => void;
}

export const UserPermissionRow: React.FC<UserPermissionRowModel> = ({
  permissionName,
  read,
  write,
  onChange,
}) => {
  const handleReadChange = (value: boolean) =>
    onChange(value ? UserPermissionValue.READ : UserPermissionValue.NONE);

  const handleWriteChange = (value: boolean) =>
    onChange(value ? UserPermissionValue.WRITE : UserPermissionValue.NONE);
  return (
    <div
      style={{
        width: '100%',
        marginTop: '24px',
        paddingBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '0.25px solid #4b5563',
      }}
    >
      <label
        style={{ marginRight: '8px', width: '300px' }}
        htmlFor="ingredient2"
        className="ml-2"
      >
        {permissionName}
      </label>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
        }}
      >
        <div>
          <Checkbox
            inputId="ingredient2"
            name="pizza"
            value="Mushroom"
            disabled={write}
            onChange={(e) => handleReadChange(!!e.checked)}
            checked={read}
          />
          <label
            style={{ marginRight: '8px' }}
            htmlFor="ingredient2"
            className="ml-2"
          >
            צפייה
          </label>
        </div>

        <div>
          <Checkbox
            inputId="ingredient2"
            name="pizza"
            value="Mushroom"
            onChange={(e) => handleWriteChange(!!e.checked)}
            checked={write}
          />
          <label
            style={{ marginRight: '8px' }}
            htmlFor="ingredient2"
            className="ml-2"
          >
            צפייה ועריכה
          </label>
        </div>
      </div>
    </div>
  );
};
